import * as yup from 'yup';

export const answerSchema = yup.object({
    answer: yup
    .string().max(250, "Input cannot exceed 250 characters"),
});

